<template>
  <div
      v-loading="loading"
      element-loading-text="正在保存中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
  >

    <!--  企业内容  -->
    <div class="parent">
      <div class="child left">
        <el-button type="warning" @click="onShowCheck('2')">通过</el-button>
        <el-button type="info" @click="onShowCheck('1')">拒绝</el-button>
        <el-form label-position="left" label-width="100px" :model="params">
          <div class="form-params">
            <el-form-item label="标题" prop="title">
              <el-input v-model="params.title" clearable type="textarea" autosize maxlength="255" disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params" v-for="(moreTitle,i) in moreTitles" :key="i">
            <el-form-item label="标题">
              <el-input v-model="moreTitle.title" maxlength="255" disabled></el-input>
            </el-form-item>
            <el-form-item label="标题颜色">
              <div class="block">
                <el-color-picker v-model="moreTitle.color" disabled></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="独占一行">
              <el-select v-model="moreTitle.display" placeholder="是否独占一行" disabled>
                <el-option
                    v-for="item in displays"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="简介" prop="desc">
              <el-input v-model="params.desc" clearable type="textarea" autosize maxlength="255" disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="企业类型" prop="newsTypeId">
              <el-cascader
                  disabled
                  :options="newsTypes"
                  :props="{ checkStrictly: true }"
                  :value="params.newsTypeId"
                  @change="newsTypeChange"
                  clearable></el-cascader>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="是否显示客服二维码" prop="isShowServerQRCode">
              <el-select v-model="params.isShowServerQRCode" placeholder="请选择" disabled>
                <el-option
                    v-for="item in displays"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-tooltip class="item" effect="dark" content="点击右上角昵称，再点击客服二维码可上传默认客服二维码" placement="top">
              <el-form-item label="是否使用默认客服二维码" prop="isDefaultServerQRCode">
                <el-select v-model="params.isDefaultServerQRCode" placeholder="请选择" disabled>
                  <el-option
                      v-for="item in displays"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-tooltip>
          </div>
          <el-form-item label="单独上传客服二维码" prop="serverQRCode" v-if="params.isDefaultServerQRCode=='否'">
            <div class="avatar-uploader">
              <el-upload
                  disabled
                  :action="fileBaseUrl"
                  :show-file-list="false"
                  :data="uploadData"
                  accept="image/*"
                  :before-upload="beforeAvatarUpload">
                <img v-if="params.serverQRCode" :src="params.serverQRCode" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="封面" prop="coverImg">
            <div class="avatar-uploader">
              <el-upload
                  disabled
                  :action="fileBaseUrl"
                  :show-file-list="false"
                  :data="uploadData"
                  :before-upload="beforeAvatarUpload">
                <img v-if="params.coverImg" :src="params.coverImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <div class="form-params">
            <el-form-item label="公司" prop="company">
              <el-input v-model="params.company" maxlength="50" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="params.contact" maxlength="50" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="座机" prop="fixedPhone">
              <el-input v-model="params.fixedPhone" maxlength="13" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="手机" prop="phone">
              <el-input v-model="params.phone" maxlength="11" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="网店" prop="onlineStore">
              <el-input v-model="params.onlineStore" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="视频主页" prop="onlineStore">
              <el-input v-model="videoIndex.linkText" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="视频号" prop="onlineStore">
              <el-input v-model="video.linkText" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="标题地点" prop="titleAddress">
              <el-input v-model="params.titleAddress" clearable disabled></el-input>
            </el-form-item>
          </div>
          <div class="form-params">
            <el-form-item label="小程序" prop="weChatMP">
              <el-input v-model="weChatMP.text" clearable disabled></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <!--  正文编辑  -->
      <div class="child right">
        <MyEditor ref="MyEditor" @cardScoreLinkClickListener="cardScoreLinkClickListener"></MyEditor>
      </div>
    </div>


    <el-dialog title="选择位置" :visible.sync="mapVisible" :fullscreen=false id="mapDialog"
               :close-on-click-modal="false" style="margin-top: 8.5vh;">
      <div style="margin-bottom: 10px">
        <label>关键词：<input v-model="keyword" class="lineinput" style="width:200px" size="mini"></label>
        <label>地区：<input v-model="location" class="lineinput" style="width:200px" size="mini"></label>
      </div>
      <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler"
                 :scroll-wheel-zoom="true"
                 @click="clickEvent"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"
                        @locationSuccess="getLoctionSuccess"></bm-geolocation>
        <bm-view :style="{width:'100%',height: '300px',flex: 1,marginTop:'0px'}"></bm-view>
        <bm-local-search :autoViewport="true" :keyword="keyword" :auto-viewport="false" :location="location"
                         style="height: 150px;overflow-y: scroll;margin: 2px 0"></bm-local-search>
      </baidu-map>
      <div class="demo-input-suffix" style="margin-top: 2vh">
        <el-link type="info">经度：</el-link>
        <el-input class="lineinput" style="width:200px" size="mini" v-model.number="locData.longitude"
                  :disabled="true"></el-input>
        <el-link type="info"> 纬度：</el-link>
        <el-input class="lineinput" style="width:200px" size="mini" v-model.number="locData.latitude"
                  :disabled="true"></el-input>
        <br>
        <el-link type="info"> 位置：</el-link>
        <el-input class="lineinput" style="width:200px" size="mini" v-model="locData.address"></el-input>
        <el-link type="info"> 字体大小：</el-link>
        <el-input class="lineinput" style="width:200px" size="mini" v-model="locData.size"></el-input>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px">
        <el-button type="warning" size="small" icon="el-icon-close" @click.native="mapVisible = false">关闭</el-button>
        <el-button type="info" size="small" icon="el-icon-close" @click="clearMarker">清空标记</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click.native="insertLocationToTitle">插入标题
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click.native="insertLocation">插入文章</el-button>
      </div>
    </el-dialog>


    <!--    插入微信小程序框-->
    <el-dialog
        title="插入小程序"
        :visible.sync="showAddWeChatMP"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addWeChatMP">
        <el-form-item label="AppId">
          <el-input
              clearable
              placeholder="请输入微信小程序的AppId"
              v-model="addWeChatMP.appid">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本">
          <el-input
              clearable
              placeholder="请输入微信小程序的链接文本"
              v-model="addWeChatMP.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addWeChatMP.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button @click="showAddWeChatMP = false">取 消</el-button>
      <el-button type="primary" @click="doAddWeChatMPTop">插入顶部</el-button>
      <el-button type="primary" @click="doAddWeChatMP">插入文章</el-button>
    </span>
    </el-dialog>

    <!--    插入视频号框-->
    <el-dialog
        title="插入视频号"
        :visible.sync="showAddShipinhao"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addShipinhao">
        <el-form-item label="视频号ID">
          <el-input
              clearable
              placeholder="请输入视频号ID"
              v-model="addShipinhao.finderUserName">
          </el-input>
        </el-form-item>
        <el-form-item label="视频ID">
          <el-input
              clearable
              placeholder="请输入视频ID"
              v-model="addShipinhao.feedId">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本">
          <el-input
              clearable
              placeholder="请输入视频号的链接文本"
              v-model="addShipinhao.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addShipinhao.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button @click="showAddShipinhao = false">取 消</el-button>
      <el-button type="primary" @click="doAddShipinhaoTop">插入顶部</el-button>
      <el-button type="primary" @click="doAddShipinhao">插入文章</el-button>
    </span>
    </el-dialog>

    <!--    插入视频号主页框-->
    <el-dialog
        title="插入视频主页"
        :visible.sync="showAddShipinhaoIndex"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="addShipinhaoIndex">
        <el-form-item label="视频号ID">
          <el-input
              clearable
              placeholder="请输入视频号ID"
              v-model="addShipinhaoIndex.finderUserName">
          </el-input>
        </el-form-item>
        <el-form-item label="链接文本">
          <el-input
              clearable
              placeholder="请输入视频号的链接文本"
              v-model="addShipinhaoIndex.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="addShipinhaoIndex.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button @click="showAddShipinhaoIndex = false">取 消</el-button>
      <el-button type="primary" @click="doAddShipinhaoTopIndex">插入顶部</el-button>
      <el-button type="primary" @click="doAddShipinhaoIndex">插入文章</el-button>
    </span>
    </el-dialog>


    <!--    插入定位 -->
    <el-dialog
        title="插入定位(只支持腾讯地图坐标)"
        :visible.sync="showAddCoord"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="coord" ref="coordForm">
        <el-form-item label="坐标" prop="lnglat"
                      :rules="[
                      {required: true, message: '请输入坐标', trigger: 'blur'},
                      {max: 255, message: '长度最高为255', trigger: 'blur'}
                      ]">
          <el-input
              clearable
              placeholder="请输入坐标"
              v-model="coord.lnglat">
          </el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address"
                      :rules="[
                      {required: true, message: '请输入地址', trigger: 'blur'},
                      {max: 255, message: '长度最高为255', trigger: 'blur'}
                      ]">
          <el-input
              clearable
              placeholder="请输入地址"
              v-model="coord.address">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小" prop="size"
                      :rules="[
                      {required: true, message: '请输入字体大小', trigger: 'blur'}
                      ]">
          <el-input
              type="number"
              placeholder="请输入链接文本字体大小"
              v-model="coord.size">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button @click="showAddCoord = false">取 消</el-button>
      <el-button type="primary" size="small" icon="el-icon-check"
                 @click="insertLocationToTitle('coordForm')">插入标题</el-button>
      <el-button type="primary" size="small" icon="el-icon-check"
                 @click="insertLocation('coordForm')">插入文章</el-button>
    </span>
    </el-dialog>


    <!--    插入佣金转账链接 -->
    <el-dialog
        title="佣金支付"
        :visible.sync="showAddScoreLink"
        width="30%"
        center>

      <el-form :model="addScoreLink" label-width="150px" ref="ScoreLinkForm">
        <el-form-item label="支付佣金" prop="score"
                      :rules="[
                    { required: true, message: '不能为空'},
                    { validator: notLeNum0, trigger: 'blur' },
                    ]">
          <el-input v-model="addScoreLink.score" type="number"></el-input>
        </el-form-item>
        <el-form-item label="接收者用户ID" prop="payId"
                      :rules="[
                      { required: true, message: '不能为空'},
                      { type: 'number', message: '必须为数字值'},
                      { validator: notLtNum1, trigger: 'blur' }
                      ]">
          <el-input v-model.number="addScoreLink.payId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="链接文本" prop="text"
                      :rules="[
                    { required: true, message: '不能为空'},
                    ]">
          <el-input
              clearable
              placeholder="请输入链接文本"
              v-model="addScoreLink.text">
          </el-input>
        </el-form-item>
        <el-form-item label="字体大小" prop="size"
                      :rules="[
                    { required: true, message: '不能为空'},
                    ]">
          <el-input
              type="number"
              placeholder="请输入链接字体大小"
              v-model="addScoreLink.size">
          </el-input>
        </el-form-item>
        <el-form-item label="字体颜色" prop="color"
                      :rules="[
                    { required: true, message: '不能为空'},
                    ]">
          <el-color-picker v-model="addScoreLink.color"></el-color-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" icon="el-icon-check"
                 @click="insertScoreLink('ScoreLinkForm')">插入文章</el-button>
    </span>

    </el-dialog>

    <!-- 设置资源宽高 -->
    <el-dialog
        title="设置宽高"
        :visible.sync="showResourceProportion"
        width="30%"
        center>
      <el-form :model="resourceProportion" label-width="150px" ref="ResourceProportionForm">
        <el-form-item label="宽度类型" prop="widthType">
          <el-select v-model="resourceProportion.widthType">
            <el-option
                v-for="item in widthHeightType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceProportion.widthType==='1'" label="自定义宽度" prop="width"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.width" type="number"></el-input>
        </el-form-item>
        <el-form-item label="高度类型" prop="heightType">
          <el-select v-model="resourceProportion.heightType">
            <el-option
                v-for="item in widthHeightType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceProportion.heightType==='1'" label="自定义高度" prop="height"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.height" type="number"></el-input>
        </el-form-item>
        <el-form-item label="圆角" prop="borderRadius"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLtNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.borderRadius" type="number"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button :disabled="resourceLoading" type="primary" icon="el-icon-check"
                     @click="insertResource('ResourceProportionForm')">插入文章</el-button>
        </span>
    </el-dialog>

    <el-dialog
        title="确认审核"
        :visible.sync="showCheck"
        width="30%"
        center>
      您确定要对该企业执行 {{ check.checkState === '2' ? '通过' : '拒绝' }} 吗？
      <el-input
          v-if="check.checkState==='1'"
          clearable
          placeholder="请输入拒绝原因"
          maxlength="255"
          v-model="check.checkReply">
      </el-input>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" icon="el-icon-check"
                     @click="doCheck">确 认</el-button>
        </span>
    </el-dialog>

    <!--    插入佣金转账链接 -->
    <el-dialog
        title="卡片佣金支付"
        :visible.sync="showAddCardScoreLink"
        width="30%"
        center>
      <div v-for="(e,i) in addCardScoreLink.resources" :key="i">
        <span v-if="e.type==='image'">
          <img :src="e.src" width="100px" height="100px">
        </span>
        <span v-else>
          <video :src="e.src" width="100px" height="150px"></video>
        </span>
        <el-button v-if="i!==0" type="info" size="mini" icon="el-icon-top" circle @click="moveResource(i, true)"></el-button>
        <el-button v-if="i!==addCardScoreLink.resources.length-1" type="info" size="mini" icon="el-icon-bottom" circle @click="moveResource(i, false)"></el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="onShowDelCardResource(i)"></el-button>
      </div>
      <el-form :model="addCardScoreLink" label-width="150px" ref="CardScoreLinkForm">
        <el-form-item label="标题" prop="title"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="请输入标题"
              v-model="addCardScoreLink.title">
          </el-input>
        </el-form-item>
        <el-form-item label="简介" prop="intro"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              type="textarea"
              clearable
              placeholder="请输入简介"
              v-model="addCardScoreLink.intro">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="用户支付需要依靠备注信息确认产品"
              v-model="addCardScoreLink.remark">
          </el-input>
        </el-form-item>
        <el-form-item label="原价佣金" prop="originScore">
          <el-input v-model="addCardScoreLink.originScore" type="number"></el-input>
        </el-form-item>
        <el-form-item label="现价佣金" prop="score">
          <el-input v-model="addCardScoreLink.score" type="number"></el-input>
        </el-form-item>
        <el-form-item label="市场价" prop="marketplaceprice">
          <el-input v-model="addCardScoreLink.marketplaceprice" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="市场价格名" prop="priceName">
          <el-input
              clearable
              placeholder="如:￥、$"
              v-model="addCardScoreLink.pricename">
          </el-input>
        </el-form-item>
        <el-form-item label="是否显示支付" prop="ispay">
          <el-select v-model="addCardScoreLink.isshowpay" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否支付" prop="ispay">
          <el-select v-model="addCardScoreLink.ispay" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收者用户ID" prop="payid">
          <el-input v-model.number="addCardScoreLink.payid" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" icon="el-icon-check" @click="insertCardScoreLink('CardScoreLinkForm')">插入文章</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>

import adminGetNewsType from "@/api/user/admin-controler/adminGetNewsType";

import {Message} from "element-ui";
import adminGetNewsContentById from "@/api/user/admin-controler/adminGetNewsContentById";
import getAliyunOssSign from "@/api/common/getAliyunOssSign"; // 引用
import Axios from 'axios';
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";
import adminAddEditNews from "@/api/user/admin-controler/adminAddEditNews";
import delMoreTitleById from "@/api/moreTitle/delMoreTitleById";
import {dateFormatToYMDHMS} from "@/utils/time";
import {notLeNum0, notLtNum0, notLtNum1} from "@/utils/check";
import checkMerchantNews from "@/api/news/checkMerchantNews";
import MyEditor from "@/components/MyEditor/MyEditor.vue";

export default {
  name: "CheckMerchantNewsManage",
  components: {
    MyEditor
  },
  data() {
    return {
      uploadData: {  //提交到OSS的参数
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
      },
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,

      btnText: undefined,
      btnType: undefined,
      displays: [
        {
          value: '是',
          label: '是',
        },
        {
          value: '否',
          label: '否',
        },
      ],
      params: {
        id: undefined,
        title: undefined,
        titleColor: '#000000',
        fixd: '是',
        fixdLock: '是',
        desc: '',
        datetime: new Date(),
        coverColor: '#FFFFFF',
        backColor: '#FFFFFF',
        titleAddress: undefined,
        titleLng: undefined,
        titleLat: undefined,
        coverImg: undefined,
        company: undefined,
        contact: undefined,
        fixedPhone: undefined,
        phone: undefined,
        onlineStore: undefined,
        content: '',
        newsTypeId: undefined,
      },
      moreTitles: [],
      videoIndex: {
        finderUserName: undefined,
        linkText: undefined,
      },
      video: {
        finderUserName: undefined,
        feedId: undefined,
        linkText: undefined,
      },
      loading: false,
      resourceLoading: false,
      newsTypes: [],

      showResourceProportion: false,
      resourceFile: undefined,
      resourceType: undefined,
      resourceProportion: {
        widthType: '0',
        width: 100,
        heightType: '0',
        height: 100,
        borderRadius: 0,
      },
      widthHeightType: [
        {
          value: '0',
          label: '原比例'
        },
        {
          value: '1',
          label: '自定义'
        },
      ],
      //即将替换的资源样式
      replaceResourceMap: new Map(),
      //原有的资源：  路径后缀 : 属性
      originResourceUrlsMap: new Map(),


      location: '',
      keyword: '',
      center: {lng: 111.752912, lat: 40.832246},
      zoom: 12,
      mapVisible: false,
      locData: {
        longitude: '',
        latitude: '',
        address: '',
        size: 20,
      },

      //富文本离开前的焦点位置
      length: 0,

      showAddScoreLink: false,
      addScoreLink: {
        score: undefined,
        payId: undefined,
        text: '【下单】',
        size: 20,
        color: '#0000FF',
      },

      showAddWeChatMP: false,
      addWeChatMP: {
        appid: undefined,
        text: '点击进入小程序',
        size: 20,
      },
      weChatMP: {
        appid: undefined,
        text: undefined,
      },
      showAddShipinhaoIndex: false,
      addShipinhaoIndex: {
        finderUserName: undefined,
        text: '点击进入视频主页',
        size: 20,
      },
      showAddShipinhao: false,
      addShipinhao: {
        finderUserName: undefined,
        feedId: undefined,
        text: '点击观看视频',
        size: 20,
      },


      showAddCoord: false,
      coord: {
        lnglat: '',
        address: '',
        size: 20,
      },

      showCheck: false,
      check: {
        id: undefined,
        checkState: '2',
        checkReply: '',
      },

      cardScoreLinkNode: null,
      showAddCardScoreLink:false,
      addCardScoreLink:{
        resources:[],
        title:undefined,
        intro:undefined,
        remark:undefined,
        originScore:undefined,
        score:undefined,
        pricename:undefined,
        marketplaceprice:undefined,
        isshowpay:'是',
        ispay:'是',
        payid:undefined,
      },

    }
  },

  methods: {
    notLtNum0,
    notLtNum1,
    notLeNum0,
    cardScoreLinkClickListener(node) {
      node.addEventListener('click', (e) => {
        this.cardScoreLinkNode = e.target
        let addCardScoreLink = JSON.parse(e.target.getAttribute('value').replaceAll('\'', '"'));
        console.log('打开卡券佣金转账弹窗')
        console.log(addCardScoreLink)
        for (let resource of addCardScoreLink.resources) {
          if (!resource.src.startsWith(this.fileBaseUrl)) resource.src = this.fileBaseUrl + resource.src
        }
        this.addCardScoreLink = addCardScoreLink
        this.showAddCardScoreLink = true
      })
    },
    doCheck(){
      const params = JSON.parse(JSON.stringify(this.check))
      params.id=this.params.id
      checkMerchantNews(params).then(res=>{
        if (res.code===1){
          Message({message:'成功',type:"success",duration:3000})
          this.$router.push({
            name: "合伙人企业",
          })
        }else{
          if (res.data && res.data.illError){
            Message({message:res.data.illError,type:"error",duration:3000})
          }else{
            Message({message:'错误',type:"error",duration:3000})
          }
        }
      })
    },
    onShowCheck(checkState) {
      this.check.checkState = checkState
      this.showCheck = true
    },

    delMoreTitle(moreTitle) {
      let data = []
      let moreTitles = this.moreTitles
      if (!moreTitle.id) {
        for (let i = 0; i < moreTitles.length; i++) {
          if (moreTitles[i].uuid !== moreTitle.uuid) data.push(moreTitles[i])
        }
      } else {
        for (let i = 0; i < moreTitles.length; i++) {
          if (moreTitles[i].id !== moreTitle.id) data.push(moreTitles[i])
        }
        delMoreTitleById(moreTitle.id).then(res => {
          if (res.code === 1) {
            Message({message: '成功', type: "success", duration: 3000})
          }
        })
      }
      this.moreTitles = data
    },
    addMoreTitle() {
      let moreTitle = {
        title: undefined,
        color: '#000000',
        display: '是',
        type: '1',
        uuid: this.getUUID()
      }
      this.moreTitles.push(moreTitle)
    },
    newsTypeChange(e) {
      if (!e || e.length == 0) {
        this.params.newsTypeId = undefined
      } else {
        this.params.newsTypeId = e[e.length - 1]
      }
    },
    doAddWeChatMPTop() {
      let addWeChatMP = this.addWeChatMP
      if (!addWeChatMP.appid) {
        return Message({
          message: '请输入AppId',
          type: "error",
          duration: 3000
        })
      }
      if (!addWeChatMP.text) {
        return Message({
          message: '请输入链接文本',
          type: "error",
          duration: 3000
        })
      }


      this.weChatMP.appid = addWeChatMP.appid
      this.weChatMP.text = addWeChatMP.text
    },
    doAddWeChatMP() {
      let addWeChatMP = this.addWeChatMP
      if (!addWeChatMP.appid) {
        return Message({
          message: '请输入AppId',
          type: "error",
          duration: 3000
        })
      }
      if (!addWeChatMP.text) {
        return Message({
          message: '请输入链接文本',
          type: "error",
          duration: 3000
        })
      }

      let quill = this.$refs.myQuillEditor.quill;
      let length = this.length
      let html = '<a style="font-size: ' + addWeChatMP.size + 'px" class="wechatmp-link" href="javascript:void(0)" contenteditable="true" value="' + addWeChatMP.appid + '">' + addWeChatMP.text + '</a>'
      quill.insertEmbed(length, 'WeChatMPLinkBlot', html);
      if (length > 0) {
        html = '<p contentEditable="true"></p>'
        quill.insertEmbed(length, 'WeChatMPLinkBlot', html);
      }
    },
    doAddShipinhaoTopIndex() {
      let addShipinhaoIndex = this.addShipinhaoIndex
      if (!addShipinhaoIndex.finderUserName) {
        return Message({
          message: '请输入视频号ID',
          type: "error",
          duration: 3000
        })
      }
      if (!addShipinhaoIndex.text) {
        return Message({
          message: '请输入链接文本',
          type: "error",
          duration: 3000
        })
      }

      this.videoIndex.finderUserName = addShipinhaoIndex.finderUserName
      this.videoIndex.linkText = addShipinhaoIndex.text
    },
    doAddShipinhaoTop() {
      let addShipinhao = this.addShipinhao
      if (!addShipinhao.finderUserName) {
        return Message({
          message: '请输入视频号ID',
          type: "error",
          duration: 3000
        })
      }
      if (!addShipinhao.feedId) {
        return Message({
          message: '请输入视频ID',
          type: "error",
          duration: 3000
        })
      }
      if (!addShipinhao.text) {
        return Message({
          message: '请输入链接文本',
          type: "error",
          duration: 3000
        })
      }

      this.video.finderUserName = addShipinhao.finderUserName
      this.video.feedId = addShipinhao.feedId
      this.video.linkText = addShipinhao.text
    },
    doAddShipinhaoIndex() {
      let addShipinhaoIndex = this.addShipinhaoIndex
      if (!addShipinhaoIndex.finderUserName) {
        return Message({
          message: '请输入视频号ID',
          type: "error",
          duration: 3000
        })
      }
      if (!addShipinhaoIndex.text) {
        return Message({
          message: '请输入链接文本',
          type: "error",
          duration: 3000
        })
      }

      let quill = this.$refs.myQuillEditor.quill;
      let length = this.length
      let html = '<a style="font-size: ' + addShipinhaoIndex.size + 'px" class="shipinhaoindex-link" href="javascript:void(0)" contenteditable="true" value="' + addShipinhaoIndex.finderUserName + '">' + addShipinhaoIndex.text + '</a>'
      quill.insertEmbed(length, 'ShipinhaoIndexLinkBlot', html);
      if (length > 0) {
        html = '<p contentEditable="true"></p>'
        quill.insertEmbed(length, 'ShipinhaoIndexLinkBlot', html);
      }
    },
    doAddShipinhao() {
      let addShipinhao = this.addShipinhao
      if (!addShipinhao.finderUserName) {
        return Message({
          message: '请输入视频号ID',
          type: "error",
          duration: 3000
        })
      }
      if (!addShipinhao.feedId) {
        return Message({
          message: '请输入视频ID',
          type: "error",
          duration: 3000
        })
      }
      if (!addShipinhao.text) {
        return Message({
          message: '请输入链接文本',
          type: "error",
          duration: 3000
        })
      }

      let quill = this.$refs.myQuillEditor.quill;
      let length = this.length
      let html = '<a style="font-size: ' + addShipinhao.size + 'px" class="shipinhao-link" href="javascript:void(0)" contenteditable="true" value="' + addShipinhao.finderUserName + ',' + addShipinhao.feedId + '">' + addShipinhao.text + '</a>'
      quill.insertEmbed(length, 'ShipinhaoLinkBlot', html);
      if (length > 0) {
        html = '<p contentEditable="true"></p>'
        quill.insertEmbed(length, 'ShipinhaoLinkBlot', html);
      }
    },
    insertScoreLink(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.addScoreLink)
          const addScoreLink = JSON.parse(JSON.stringify(this.addScoreLink))
          let quill = this.$refs.myQuillEditor.quill;
          let length = this.length
          let html = '<a style="font-size: ' + addScoreLink.size + 'px;color: ' + addScoreLink.color + ';" class="score-link" href="javascript:void(0)" contenteditable="true" value="' + addScoreLink.score + ',' + addScoreLink.payId + '">' + addScoreLink.text + '</a>'
          quill.insertEmbed(length, 'ScoreLinkBlot', html);
          if (length > 0) {
            html = '<p contentEditable="true"></p>'
            quill.insertEmbed(length, 'ScoreLinkBlot', html);
          }
          this.showAddScoreLink = false
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowAddScoreLink() {
      this.showAddScoreLink = true
    },
    onShowAddWeChatMP() {
      this.showAddWeChatMP = true
    },
    onShowAddShipinhaoIndex() {
      this.showAddShipinhaoIndex = true
    },
    onShowAddShipinhao() {
      this.showAddShipinhao = true
    },
    positioning() {
      this.showAddCoord = true


      // this.mapVisible = true
    },
    handler({BMap, map}) {
      let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        console.log(r);
        _this.center = {lng: r.longitude, lat: r.latitude};   // 设置center属性值
        _this.autoLocationPoint = {lng: r.longitude, lat: r.latitude};  // 自定义覆盖物
        _this.initLocation = true;
      }, {enableHighAccuracy: true})
      window.map = map;
      window.BMap = BMap;
    },
    //点击地图监听
    clickEvent(e) {
      window.map.clearOverlays();
      let Icon_0 = new window.BMap.Icon("https://hl-tianxia.oss-cn-chengdu.aliyuncs.com/upload/common/map.png", new window.BMap.Size(64, 64), {
        anchor: new window.BMap.Size(18, 32),
        imageSize: new window.BMap.Size(36, 25)
      });
      let myMarker = new window.BMap.Marker(new window.BMap.Point(e.point.lng, e.point.lat), {icon: Icon_0});
      window.map.addOverlay(myMarker);
      //用所定位的经纬度查找所在地省市街道等信息
      let point = new window.BMap.Point(e.point.lng, e.point.lat);
      let gc = new window.BMap.Geocoder();
      let _this = this;
      gc.getLocation(point, function (rs) {
        let addComp = rs.addressComponents;
        console.log(addComp)
        _this.locData.address = rs.address;

      });
      this.locData.longitude = e.point.lng;
      this.locData.latitude = e.point.lat;
    },

    //清空标记
    clearMarker() {
      let keyword = this.keyword
      let location = this.location
      this.keyword = keyword + 'a'
      this.location = location + 'a'
      let that = this
      let timer = setInterval(function () {
        that.keyword = keyword
        that.location = location
        clearInterval(timer)
      }, 1000)
      this.locData = {
        longitude: '',
        latitude: '',
        address: '',
      }
    },

    //定位成功回调
    getLoctionSuccess(point) {
      window.map.clearOverlays();
      let Icon_0 = new window.BMap.Icon("https://hl-tianxia.oss-cn-chengdu.aliyuncs.com/upload/common/map.png", new window.BMap.Size(64, 64), {
        anchor: new window.BMap.Size(18, 32),
        imageSize: new window.BMap.Size(36, 36)
      });
      let myMarker = new window.BMap.Marker(new window.BMap.Point(point.point.lng, point.point.lat), {icon: Icon_0});
      window.map.addOverlay(myMarker);
      this.locData.longitude = point.point.lng;
      this.locData.latitude = point.point.lat;
    },

    insertLocationToTitle(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const lnglat = this.coord.lnglat.split(',')
          if (lnglat.length != 2) return Message({message: '请正确输入坐标', type: "error", duration: 3000})
          this.params.titleLng = lnglat[1]
          this.params.titleLat = lnglat[0]
          this.params.titleAddress = this.coord.address
          this.showAddCoord = false
          Message({
            message: "成功",
            type: "success",
            duration: 3000
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });


      // let lng = this.locData.longitude
      // let lat = this.locData.latitude
      // let address = this.locData.address
      // if(!lng || !lat || !address){
      //   return Message({
      //     message:'请点击地图选择地点 ',
      //     type: "error",
      //     duration: 3000,
      //   })
      // }
      // // console.log('插入位置至标题')
      // adminGetCoords({lng:lng,lat:lat}).then(res=>{
      //   let data = JSON.parse(res.data)
      //   let coords = data.result[0]
      //   this.params.titleAddress = address
      //   this.params.titleLng = coords.x
      //   this.params.titleLat = coords.y
      //   // console.log(this.params)
      //   Message({
      //     message: "成功",
      //     type: "success",
      //     duration: 3000
      //   })
      // })
    },

    //插入位置
    insertLocation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const lnglat = this.coord.lnglat.split(',')
          if (lnglat.length != 2) return Message({message: '请正确输入坐标', type: "error", duration: 3000})
          let html = '<a class="address" href="javascript:void(0)" contenteditable="true" style="font-size: ' + this.coord.size + 'px" value="' + lnglat[1] + ',' + lnglat[0] + '">' + this.coord.address + '</a>'
          let quill = this.$refs.myQuillEditor.quill;
          let length = this.length
          quill.insertEmbed(length, 'AddressBlot', html);
          if (length > 0) {
            html = '<p contentEditable="true"></p>'
            quill.insertEmbed(length, 'AddressBlot', html);
          }

          this.showAddCoord = false
          Message({
            message: "成功",
            type: "success",
            duration: 3000
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });


      // let lng = this.locData.longitude
      // let lat = this.locData.latitude
      // let address = this.locData.address
      // let size = this.locData.size
      // if(!lng || !lat || !address){
      //   return Message({
      //     message:'请点击地图选择地点 ',
      //     type: "error",
      //     duration: 3000,
      //   })
      // }
      //
      // let quill = this.$refs.myQuillEditor.quill;
      // let length = this.length
      // adminGetCoords({lng:lng,lat:lat}).then(res=>{
      //   let data = JSON.parse(res.data)
      //   let coords = data.result[0]
      //   let html = '<a class="address" href="javascript:void(0)" contenteditable="true" style="font-size: '+size+'px" value="'+coords.x+','+coords.y+'">'+address+'</a>'
      //   quill.insertEmbed(length, 'AddressBlot', html);
      //   if(length>0){
      //     html = '<p contentEditable="true"></p>'
      //     quill.insertEmbed(length, 'AddressBlot', html);
      //   }
      //   Message({
      //     message: "成功",
      //     type: "success",
      //     duration: 3000
      //   })
      // })


    },

    doConfirm() {
      if (!this.params.title) {
        return Message({
          message: '请输入标题',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if (!this.params.titleColor) {
        return Message({
          message: '请选择标题颜色',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if (!this.params.datetime) {
        return Message({
          message: '请选择时间',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if (!this.params.newsTypeId) {
        return Message({
          message: '请选择企业类型',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if (!this.params.coverImg) {
        return Message({
          message: '请上传封面图片',
          type: 'error',
          duration: 3 * 1000
        });
      }
      if (this.params.isDefaultServerQRCode=='否' && !this.params.serverQRCode){
        return Message({
          message: '不使用默认客服二维码时必须单独上传客服二维码！',
          type: 'error',
          duration: 3 * 1000
        });
      }

      this.loading = true

      //检测文档中的图片样式是否有对齐方式
      const imgs = document.querySelectorAll('.quill img')
      imgs.forEach(img => {
        if (img.src.startsWith(this.fileBaseUrl)) {
          console.log('记录图片对齐方式')
          console.log(img)


          //    display: inline; float: left; margin: 0px 1em 1em 0px;
          let moreStyle = ' '
          if (img.style.display) {
            moreStyle += 'display: ' + img.style.display + ';'
          }
          if (img.style.float) {
            moreStyle += 'float: ' + img.style.float + ';'
          }
          if (img.style.margin) {
            moreStyle += 'margin: ' + img.style.margin + ';'
          }
          moreStyle += '"'
          console.log('更多样式')
          console.log(moreStyle)
          let key = img.src.substring(img.src.length - 15) + '"'
          console.log(key)

          let value = ''
          if (this.replaceResourceMap.has(key)) {
            console.log('原来拥有')
            value = this.replaceResourceMap.get(key)
            value = value.substring(0, value.length - 1) + moreStyle
          } else {
            console.log('No')
            value = key + ' style="' + moreStyle
          }
          this.replaceResourceMap.set(key, value)
        }
      })

      this.replaceResourceMap.forEach((value, key) => {
        console.log('改变资源样式')
        console.log(key)
        console.log(value)
        this.params.content = this.params.content.replace(key, value)
      })

      if (this.params.content) {
        let newContent = this.params.content.replaceAll(this.fileBaseUrl, "").replaceAll("/upload/news/", '/upload/temp/')
        this.params.content = newContent
      }
      this.params.coverImg = this.params.coverImg.substring(this.fileBaseUrl.length).replace('/upload/news/', '/upload/temp/').substring(1)

      let coverImg = this.params.coverImg.split("?")[0]
      this.params.coverImg = coverImg

      let content = this.params.content
      let rex = /upload\/temp\/[.\w\d-?=&;%]*/g
      let result = undefined
      let arr = new Set()
      while ((result = rex.exec(content)) != null) {
        arr.add(result[0])
      }
      arr.forEach(e => {
        content = content.replaceAll(e, e.split("?")[0])
      })
      this.params.content = content
      if (this.video.finderUserName && this.video.feedId && this.video.linkText) {
        this.params.video = this.video.finderUserName + ',' + this.video.feedId + ',' + this.video.linkText
      }
      if (this.video.linkText == '') {
        this.params.video = ''
      }
      if (this.videoIndex.finderUserName && this.videoIndex.linkText) {
        this.params.videoIndex = this.videoIndex.finderUserName + ',' + this.videoIndex.linkText
      }
      if (this.videoIndex.linkText == '') {
        this.params.videoIndex = ''
      }
      if (this.weChatMP.appid && this.weChatMP.text) {
        this.params.weChatMP = this.weChatMP.appid + ',' + this.weChatMP.text
      }
      if (this.weChatMP.text == '') {
        this.params.weChatMP = ''
      }

      this.params.moreTitles = this.moreTitles

      this.params.datetime = dateFormatToYMDHMS(new Date(this.params.datetime))

      adminAddEditNews(this.params).then(res => {
        if (res.code != 1) {
          if (res.data) {
            if (res.data.title) {
              Message({
                message: res.data.title,
                type: 'error',
                duration: 3 * 1000
              });
            }
            if (res.data.coverImg) {
              Message({
                message: res.data.coverImg,
                type: 'error',
                duration: 3 * 1000
              });
            }
            if (res.data.newsTypeId) {
              Message({
                message: res.data.newsTypeId,
                type: 'error',
                duration: 3 * 1000
              });
            }
          }
          this.params.coverImg = this.fileBaseUrl + this.params.coverImg
        } else {
          Message({
            message: '成功',
            type: 'success',
            duration: 3 * 1000
          });
          this.$router.push({
            name: "企业管理",
          })
        }
        this.loading = false
      })
    },
    async beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGIF = file.type === 'image/gif';

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error('上传头像图片只能是 JPG或PNG或GIF 格式!');
      }
      this.loading = true
      if (isJPG || isPNG || isGIF) {
        await getAliyunOssSign("/common/sign").then(response => {
          console.log(response)
          //设置相关的参数
          let resultObj = response.data;
          this.uploadData.policy = resultObj.policy;
          this.uploadData.signature = resultObj.signature;
          this.uploadData.ossaccessKeyId = resultObj.accessid;
          //上传的文件名，使用UUID处理一下
          this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
          this.uploadData.dir = resultObj.dir;
          this.uploadData.host = resultObj.host;
          console.log('签名')
          console.log(this.uploadData)
        });
        return true
      }
      return false
    },
    handleAvatarSuccess(response, file) {
      adminGetFileSignUrl(this.uploadData.key.replace("${filename}", file.name)).then(res => {
        this.params.coverImg = res.data
        this.loading = false
      })
    },
    getNewsType() {
      adminGetNewsType().then(res => {
        let types = res.data
        types.sort((a, b) => a.order - b.order)

        let map = new Map()
        for (let i = 0; i < types.length; i++) {
          let type = types[i]
          if (type.parentId == 0) continue
          let children = map.get(type.parentId)
          if (!children) {
            children = []
          }
          children.push({
            value: type.id,
            label: type.name
          })
          map.set(type.parentId, children)
        }

        let data = []
        for (let i = 0; i < types.length; i++) {
          let type = types[i]
          if (type.parentId > 0) continue
          if (map.has(type.id)) {
            type.children = map.get(type.id)
          }
          data.push({
            value: type.id,
            label: type.name,
            children: type.children
          })
        }

        this.newsTypes = data
      })
    },


    onEditorChange(event) {
      let html = event.html
      html = html.replaceAll('div', 'p')
      this.params.content = html
    },
    onEditorBlur(quill) {
      // console.log('失去焦点')
      // console.log(quill.getSelection())
      let sel = quill.getSelection()
      if (sel) {
        let index = sel.index
        if (index) {
          return this.length = index
        }
      }
      this.length = this.params.content.length
    },
    onEditorFocus() {
      // this.length = quill.getSelection().index
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    insertResource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadFile(this.resourceFile, this.resourceType)
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    resouceProportion(file, type) {
      console.log('打开资源宽高设置')
      this.resourceFile = file
      this.resourceType = type
      this.showResourceProportion = true
    },
    //上传视频到服务器
    changeimage(file) {
      this.resouceProportion(file, 'image')
    },

    //上传图片到服务器
    changevideo(file) {
      this.resouceProportion(file, 'video')
    },

    uploadFile(file, type) {
      this.loading = true
      this.resourceLoading = true
      getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        //上传的文件名，使用UUID处理一下
        let pre = resultObj.dir + '/' + this.getUUID() + '_'
        file = file.target.files[0];
        console.log(pre)
        console.log(file)
        let data = new FormData();
        data.append("key", pre + '${filename}')
        data.append("OSSAccessKeyId", resultObj.accessid)
        data.append("policy", resultObj.policy)
        data.append("signature", resultObj.signature)
        data.append("file", file)
        data.append("success_action_status", 200)

        let config = {
          'Content-Type': 'multipart/form-data'
        }
        Axios.post(resultObj.host, data, config).then((res) => {
          if (res.status == 200) {
            adminGetFileSignUrl(pre + file.name).then(res => {
              if (type == 'image') {
                this.insertImg("image", res.data);
              }
              if (type == 'video') {
                this.insertEle("video", res.data);
              }
              Message({
                message: '上传成功',
                type: 'success',
                duration: 3 * 1000
              });
              this.loading = false
              this.resourceLoading = false
              this.showResourceProportion = false
            })

          }
        }).catch(err => {
          Message({
            message: '上传失败' + err.getMessage(),
            type: 'error',
            duration: 3 * 1000
          });
          this.loading = false
          this.resourceLoading = false
        })
      });

    },

    processWatchResource(resources) {
      const that = this
      const clazz = 'resource-resize'
      resources.forEach(function (img) {
        console.log('检测到资源文件')
        console.log(img)
        if (img.classList.contains(clazz)) {
          // 图片已经调整过大小，跳过
          console.log('图片已经调整过，跳过')
          console.log(img)
          return;
        }
        console.log('检测到图片了')
        console.log(img)
        let src = img.src.toString() + '"'
        // 'https://hltx-test.oss-cn-chengdu.aliyuncs.com/upload/temp/'
        if (src.startsWith(that.fileBaseUrl + '/upload/temp/')) {

          let otherStr = ' class="' + clazz + '" style="'

          if (that.resourceProportion.widthType === '1') {
            img.style.width = that.resourceProportion.width + 'px'
            otherStr += 'width: ' + that.resourceProportion.width + 'px; '
          }
          if (that.resourceProportion.heightType === '1') {
            img.style.height = that.resourceProportion.height + 'px'
            otherStr += 'height: ' + that.resourceProportion.height + 'px; '
          }
          img.style.borderRadius = that.resourceProportion.borderRadius + 'px'
          otherStr += 'border-radius: ' + that.resourceProportion.borderRadius + 'px;"'
          img.classList.add(clazz); // 添加标记，表示已调整大小


          //加入即将替换的样式
          src = src.substring(src.length - 16, src.length)
          otherStr = src + otherStr.toString()
          console.log('加入即将替换的样式')
          console.log(src)
          console.log(otherStr)
          that.replaceResourceMap.set(src, otherStr)
        }

        //判断是否是原有图片
        let originSrc = img.src.substring(img.src.length - 16)
        if (that.originResourceUrlsMap.has(originSrc)) {
          const info = that.originResourceUrlsMap.get(originSrc)
          console.log(info)
          img.style.width = info.width
          img.style.height = info.height
          img.style.borderRadius = info.borderRadius
          img.style.display = info.display
          img.style.float = info.float
          img.style.margin = info.margin
          img.classList.add(clazz); // 添加标记，表示已调整大小

          let otherStr = ' class="' + clazz + '" style="'
          if (info.width) {
            otherStr += 'width: ' + info.width + '; '
          }
          if (info.height) {
            otherStr += 'height: ' + info.height + '; '
          }
          otherStr += 'border-radius: ' + info.borderRadius + ';"'
          //加入即将替换的样式
          originSrc = originSrc.substring(1) + '"'
          otherStr = originSrc + otherStr.toString()
          console.log('==============================')
          console.log(originSrc)
          console.log(otherStr)
          that.replaceResourceMap.set(originSrc, otherStr)
          console.log(that.replaceResourceMap)
        }

      });
    },
    watchResource() {
      const videos = document.querySelectorAll('.quill video');
      const images = document.querySelectorAll('.quill img');
      this.processWatchResource(videos)
      this.processWatchResource(images)

      return true
    },

    // 图片上传事件
    insertImg(type, url) {
      const myQuillEditor = this.$refs.myQuillEditor;
      const quill = myQuillEditor.quill
      let length = this.length
      // 插入视频  url为服务器返回的图片地址
      if (type === "image") {
        quill.insertEmbed(length, "image", url);
      } else {
        quill.insertEmbed(length, type, url);
      }
      // 调整光标到最后
      quill.setSelection(length + 1);
    },
    //视频上传事件
    insertEle(type, url) {
      let quill = this.$refs.myQuillEditor.quill;
      let length = this.length
      // 插入视频  url为服务器返回的图片地址
      if (type === "video") {
        quill.insertEmbed(length, "simpleVideo", {url, width: '100%', height: 'auto', controls: 'controls'});
      } else {
        quill.insertEmbed(length, type, url);
      }
      // 调整光标到最后
      quill.setSelection(length + 1);
    },

//处理粘贴事件
    processParse(node, delta) {
      // console.log(node)
      // console.log(delta)
      let ops = []
      delta.ops.forEach(async (op) => {
        if (
            op.insert && typeof op.insert !== 'string'
            && op.insert.image
            && op.insert.image.includes(';base64')
        ) {  // 如果粘贴了图片，这里会是一个对象
          this.loading = true
          getAliyunOssSign("/common/sign").then(response => {
            let file = this.dataURLtoFile(op.insert.image, `paste-${Math.random().toString(36).slice(-8)}.png`)
            //设置相关的参数
            let resultObj = response.data;
            //上传的文件名，使用UUID处理一下
            let pre = resultObj.dir + '/' + this.getUUID() + '_'
            let data = new FormData();
            data.append("key", pre + '${filename}')
            data.append("OSSAccessKeyId", resultObj.accessid)
            data.append("policy", resultObj.policy)
            data.append("signature", resultObj.signature)
            data.append("file", file)
            data.append("success_action_status", 200)

            let config = {
              'Content-Type': 'multipart/form-data'
            }
            Axios.post(resultObj.host, data, config).then((res) => {
              if (res.status == 200) {
                adminGetFileSignUrl(pre + file.name).then(res => {
                  this.insertImg("image", res.data);
                  Message({
                    message: '上传成功',
                    type: 'success',
                    duration: 3 * 1000
                  });
                  this.loading = false
                })
              }
            }).catch(err => {
              Message({
                message: '上传失败' + err.getMessage(),
                type: 'error',
                duration: 3 * 1000
              });
              this.loading = false
            })
          });
        } else {
          ops.push(op)
        }
      })
      delta.ops = ops
      return delta
    },
    dataURLtoFile(dataurl, name) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], name, {type: mime})
    },
    processExtractResourceInfo(tags) {
      // 遍历<img>标签并打印其src属性的值
      tags.forEach(img => {
        console.log('检测到资源属性')
        console.log(img);
        const info = {
          width: img.style.width,
          height: img.style.height,
          borderRadius: img.style.borderRadius,
          display: img.style.display,
          float: img.style.float,
          margin: img.style.margin,
        }
        let src = img.src.toString()
        src = src.substring(src.length - 16)
        this.originResourceUrlsMap.set(src, info)
      });
    },
    extractResourceInfo(content) {
      // 使用DOMParser解析HTML文本
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      // 获取所有<img>标签
      const imgTags = doc.querySelectorAll('img');
      this.processExtractResourceInfo(imgTags)
      const videoTags = doc.querySelectorAll('video');
      this.processExtractResourceInfo(videoTags)
    },
    getNewsById() {
      if (this.params.id) {
        adminGetNewsContentById(this.params.id).then(res => {
          if (res.code == 1) {
            const news = JSON.parse(JSON.stringify(res.data))
            this.$refs.MyEditor.setContent(news.content.replaceAll("src=\"/upload/news", "src=\"" + this.fileBaseUrl + "/upload/news"))

            news.serverQRCode = news.serverQRCode ? this.fileBaseUrl + news.serverQRCode : ''
            news.coverImg = this.fileBaseUrl + news.coverImg
            const moreTitles = news.moreTitles
            moreTitles.sort((a, b) => a.id - b.id)
            this.moreTitles = moreTitles

            if (news.provinceId && news.cityId && news.areaId) {
              news.areaDetailId = [news.provinceId, news.cityId, news.areaId]
            } else {
              news.areaDetailId = []
            }

            const video = news.video
            if (video) {
              const vs = video.split(',')
              this.video.finderUserName = vs[0]
              this.addShipinhao.finderUserName = vs[0]
              this.video.feedId = vs[1]
              this.addShipinhao.feedId = vs[1]
              this.video.linkText = vs[2]
              this.addShipinhao.linkText = vs[2]
            }
            const videoIndex = news.videoIndex
            if (videoIndex) {
              const vs = videoIndex.split(',')
              this.videoIndex.finderUserName = vs[0]
              this.addShipinhaoIndex.finderUserName = vs[0]
              this.videoIndex.linkText = vs[1]
              this.addShipinhaoIndex.linkText = vs[1]
            }
            const weChatMP = news.weChatMP
            if (weChatMP) {
              const vs = weChatMP.split(',')
              this.weChatMP.appid = vs[0]
              this.addWeChatMP.appid = vs[0]
              this.weChatMP.text = vs[1]
              this.addWeChatMP.text = vs[1]
            }

            this.params = news
          }
        })
      }
    },
    fetchData() {
      this.getNewsType()
      this.getNewsById()
    },
  },

  created() {
    const checkMerchantNewsId = localStorage.getItem('checkMerchantNewsId')
    if (checkMerchantNewsId !== null && checkMerchantNewsId !== 'undefined') {
      this.params.id = checkMerchantNewsId
    }
  },
  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
@import "../../../styles/news/news.scss";
@import "../../../styles/news/font-face.css";
@import "../../../styles/news/font.css";

</style>
